var map = {
	"./Green-VeryLow.png": 1073,
	"./Green-VeryLow.svg": 2770,
	"./Red-Excessive.png": 1069,
	"./Red-Excessive.svg": 2771,
	"./RedYellow-Significant.png": 1070,
	"./RedYellow-Significant.svg": 2772,
	"./White-Unknown.png": 623,
	"./White-Unknown.svg": 2773,
	"./Yellow-Moderate.png": 1071,
	"./Yellow-Moderate.svg": 2774,
	"./YellowGreen-Low.png": 1072,
	"./YellowGreen-Low.svg": 2775
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2769;


//////////////////
// WEBPACK FOOTER
// ./static/images/delay-map ^\.\/.*$
// module id = 2769
// module chunks = 1